import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from '../../store'
import {adminPasswordUpdateRequest, GetProfileRequest, resentOtpRequest} from '../../../api/endpoints/auth'

export interface AuthState {
  isLoggedIn: boolean
  currentUser: CurrentUser
  status: string
  user: any
  timer:number
}

export interface CurrentUser {
  id: number
  firstName: string
  lastName: string
  email: string
  username: string
  mobileNo: string
  profileImage: string
  access_token: string
  refresh_token: string
  expires_in_minute :number
  remaining_time_in_minutes:number
}

export const initialState: AuthState = {
  isLoggedIn: false,
  status: 'idle',
  user: {},
  timer:0,
  currentUser: {
    id: 0,
    firstName: '',
    lastName: '',
    email: '',
    username: '',
    mobileNo: '',
    profileImage: '',
    access_token: '',
    refresh_token: '',
    expires_in_minute :0,
    remaining_time_in_minutes:0,
  },
}

export const getProfileAction = createAsyncThunk('get/profile', async (token: string) => {
  try {
    const res: any = await GetProfileRequest(token)
    const {data, success} = res.data
    return {
      data,
      success,
      code: 200,
    }
  } catch (error) {
    return error
  }
})

export const adminUpdatePasswordAction = createAsyncThunk(
  'update/admin-password',
  async (rData: any) => {
    try {
      const res: any = await adminPasswordUpdateRequest(rData.data)
      const {data, success} = res.data
      if (success) {
        rData.SHOW_SUCCESS(true, 'Password updated successfully')
        rData.handleClose()
      }
      return {
        data,
        success,
        code: 200,
      }
    } catch (error) {}
  }
)

export const resentOtpAction = createAsyncThunk(
  "/resent-otp",
  async (rData: { email: string }) => { 
    try {
      console.log("Resent OTP Request Payload:", rData); // Debugging statement
      const res: any = await resentOtpRequest(rData); 
      console.log("Resent OTP Response:", res.data); // Debugging statement

      const { success, message, expires_in_minutes } = res.data; // Extracting expires_in_minutes

      if (success) {
        console.log("OTP resent successfully!");
      }

      return {
        success,
        message,
        expires_in_minutes, // Include this in the return value
        code: 200,
      };
    } catch (error) {
      console.error("Error resending OTP:", error);
      throw error;
    }
  }
);



const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logIn: (state, { payload }: PayloadAction<CurrentUser>) => {
      state.currentUser = payload;
      state.isLoggedIn = true;
     state.timer = payload.expires_in_minute || payload.remaining_time_in_minutes;
    },
    setLogOut: (state) => {
      state = initialState
    },
  },
  extraReducers(builder) {
    builder.addCase(getProfileAction.pending, (state, action) => {
      state.status = 'loading'
    })
    builder.addCase(getProfileAction.fulfilled, (state, action: any) => {
      state.status = 'success'
      state.user = action.payload.data
    })
    builder.addCase(getProfileAction.rejected, (state, action) => {
      state.status = 'failed'
    })

    builder.addCase(resentOtpAction.pending, (state, action) => {
      state.status = 'loading'
    })
    builder.addCase(resentOtpAction.fulfilled, (state, action) => {
      state.status = "success";
      state.timer = action.payload.expires_in_minutes; 
    });
    
    builder.addCase(resentOtpAction.rejected, (state, action) => {
      state.status = 'failed'
    })

    builder.addCase(adminUpdatePasswordAction.pending, (state, action) => {
      state.status = 'loading'
    })
    builder.addCase(adminUpdatePasswordAction.fulfilled, (state, action) => {
      state.status = 'success'
    })
    builder.addCase(adminUpdatePasswordAction.rejected, (state, action) => {
      state.status = 'failed'
    })
  },
})

export const {logIn, setLogOut} = authSlice.actions
export default authSlice.reducer

export const authSelector = (state: RootState) => state.auth
export const getIsLoggedIn = (state: RootState) => state?.auth.isLoggedIn
export const getLoggedInUserDataSelector = (state: RootState) => state?.auth.user
